/**
 * Pure helpers behind `MultiValueInput`'s paste / commit splitting: a
 * comma- (or newline-/tab-) separated list becomes separate chips.
 */

/**
 * Chip separators: comma, CR, LF, tab. Semicolons are deliberately NOT
 * separators — they appear inside real values (company names such as
 * "Acme; Inc", free-text titles), while a rep pasting a list from a
 * spreadsheet or doc produces commas, newlines or tabs.
 */
export const CHIP_SEPARATOR = /[,\r\n\t]+/;

/** Trimmed, non-empty, exact-deduped tokens in original order. */
export function splitChipText(raw: string): string[] {
  const out: string[] = [];
  for (const part of raw.split(CHIP_SEPARATOR)) {
    const token = part.trim();
    if (token && !out.includes(token)) out.push(token);
  }
  return out;
}

/**
 * Appends the chips encoded in `raw` to `existing`. Tokens already in
 * `existing` (exact) are dropped (in-paste duplicates are already removed by
 * `splitChipText`). Returns `existing` itself when nothing is new.
 */
export function appendChips(existing: string[], raw: string): string[] {
  const added = splitChipText(raw).filter(t => !existing.includes(t));
  return added.length ? [...existing, ...added] : existing;
}
